'use client';
import React, { useState } from 'react';
import { PostCard } from '@benzinga/news';
import styled from '@benzinga/themetron';
import { Spinner, Button } from '@benzinga/core-ui';
import { ContentManager } from '@benzinga/content-manager';
import { SessionContext } from '@benzinga/session-context';
import { isPaywallArticle, isProOnlyPost } from '@benzinga/article-manager';

interface PostFeedProps {
  attrs?: any;
  posts: any[];
}

const nodeUrl = node => {
  return node.url;
};

export const PostFeedBlock: React.FC<PostFeedProps> = ({ attrs, posts }) => {
  const nodes = posts ?? attrs?.data.posts;
  const [didLoad, setDidLoad] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [newPosts, setNewPosts] = useState<any>([]);
  const [pageCount, setPageCount] = useState<any>(1);
  const session = React.useContext(SessionContext);
  const [contentManager] = React.useState(session.getManager(ContentManager));

  if (!nodes || nodes.length < 1) {
    return <div />;
  }
  const loadNewData = () => {
    setIsLoading(true);

    const query = attrs?.data?.query;

    if (query) {
      const queryData = {
        category: query.category ? query.category.join(',') : null,
        limit: 10,
        meta_key: query.meta_key ?? null,
        meta_value: query.meta_value ?? null,
        page: pageCount,
        page_types: query.page_types ? query.page_types.join(',') : null,
        post_feed_type: query.post_feed_type ?? 'post',
        vertical: query.verticals ? query.verticals.join(',') : null,
      };

      contentManager
        .getPosts(queryData)
        .then(data => {
          if (Array.isArray(data.ok) && data.ok.length) {
            const resData = data.ok.map((post: any) => postComponent(post));
            const resHtml = [...newPosts, ...resData];
            setNewPosts(resHtml);

            const Count = pageCount + 1;
            setPageCount(Count);
          } else {
            setDidLoad(false);
          }
        })
        .catch(reason => {
          console.error('Post Feed', reason);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const postComponent = post => {
    const url = nodeUrl(post);
    const hasEdgeBadge = post ? isPaywallArticle(post) : false;
    const showProBadge = post ? isProOnlyPost(post) : false;
    return (
      <PostCard
        created={post.published_at}
        description={post.description}
        hasEdgeBadge={hasEdgeBadge}
        id={post.id}
        image={post.image}
        key={`post-${post.id}`}
        layout="feed"
        showProBadge={showProBadge}
        title={post.title}
        url={url}
      />
    );
  };
  return (
    <PostFeedWrapper>
      {nodes.map((post, i) => {
        const url = nodeUrl(post);
        const hasEdgeBadge = post ? isPaywallArticle(post) : false;
        const showProBadge = post ? isProOnlyPost(post) : false;
        return (
          <PostCard
            created={post.published_at}
            description={post.description}
            hasEdgeBadge={hasEdgeBadge}
            id={post.id}
            image={post.image ?? post.thumbnail}
            key={`post-${i}`}
            layout="feed"
            showProBadge={showProBadge}
            title={post.title}
            url={url}
          />
        );
      })}
      {newPosts && <>{newPosts.map(feed => feed)}</>}
      {attrs?.data && attrs?.data.action === 'load_more' && (
        <div className="text-center">
          {isLoading ? <Spinner /> : null}
          {!isLoading && didLoad ? (
            <div className={'load-more-section'}>
              <Button onClick={loadNewData} variant={'cta'}>
                Load More
              </Button>
            </div>
          ) : null}
        </div>
      )}
    </PostFeedWrapper>
  );
};

export const PostFeedWrapper = styled.div`
  .post-card {
    margin-bottom: 1rem;
  }
  .load-more-section {
    text-align: center;
    button {
      width: auto !important;
    }
  }
`;
